<template>
  <div class="p-fluid">
    <div class="card">
      <h5 class="p-text-center">Creacion de configuracion de Email</h5>
      <form @submit.prevent="handleSubmit(!v$.$invalid)">
        <div class="p-field p-col-12 p-md-3">
          <label for="plantilla">Plantilla</label>
          <Dropdown
            id="plantilla"
            v-model="v$.plantilla.$model"
            :options="plantillas"
            optionLabel="name"
            placeholder="Seleccione Plantilla"
          ></Dropdown>
        </div>

        <div class="p-field p-col-12 p-md-4">
          <span class="p-float-label">
            <InputText
              id="name"
              v-model="v$.name.$model"
              :class="{ 'p-invalid': v$.name.$invalid && submitted }"
            />
            <label
              for="name"
              :class="{ 'p-error': v$.name.$invalid && submitted }"
              >Name*</label
            >
          </span>
          <small
            v-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response"
            class="p-error"
            >{{ v$.name.required.$message.replace('Value', 'Name') }}</small
          >
        </div>
        <div class="p-field p-col-12 p-md-4">
          <span class="p-float-label">
            <InputText
              id="subjectText"
              v-model="v$.subjectText.$model"
              :class="{ 'p-invalid': v$.subjectText.$invalid && submitted }"
            />
            <label
              for="subjectText"
              :class="{ 'p-error': v$.subjectText.$invalid && submitted }"
              >Subject*</label
            >
          </span>
          <small
            v-if="
              (v$.subjectText.$invalid && submitted) ||
                v$.subjectText.$pending.$response
            "
            class="p-error"
            >{{
              v$.subjectText.required.$message.replace('Value', 'Name')
            }}</small
          >
        </div>

        <div class="p-field-checkbox">
          <InputSwitch id="active" v-model="v$.active.$model" />
          <label class="p-label" for="active">Activo</label>
        </div>

        <div class="p-d-flex p-jc-center">
          <div class="p-mr-2"><Button type="submit" label="Guardar" /></div>
          <router-link to="/emailconfig">
            <div class="p-mr-2"><Button type="button" label="Cancel" /></div>
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { apiPost, apiGet } from '../../helpers/rest-api';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      plantillas: [],
      name: '',
      subjectText: '',
      plantilla: { id: '137', name: '333' },
      submitted: false,
      active: false,
    };
  },
  validations() {
    return {
      name: {
        required,
      },
      subjectText: {
        required,
      },
      plantilla: {
        required,
      },
      active: {
        required: false,
      },
    };
  },
  mounted() {
    this.getAll();

    this.plantilla = 137;
  },
  methods: {
    getAll() {
      apiGet('plantilla').then((response) => (this.plantillas = response.data));
    },

    handleSubmit(isFormValid) {
      this.submitted = true;

      if (!isFormValid) {
        return;
      }

      const { name, subjectText, plantilla, active } = this;

      apiPost(
        'emailconfig',
        JSON.stringify({ name, subjectText, plantilla, active })
      ).then(() => this.$router.push('/emailconfig'));
    },
  },
};
</script>

<!-- -->
